<template>
  <UiSectionWrapper
    title="Kendalikan Bisnis Anda dengan Data yang Berbicara"
    sub-title="Dashboard Member"
    description="Waktu Anda terlalu berharga untuk laporan manual. Gunakan Dashboard Member KiriminAja dan temukan efisiensi baru dalam setiap pengiriman."
    hero-image="/images/dashboard-member-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Masuk ke Dashboard Member"
    :button-link="$utm.utmUrl('/login')"
  />
</template>
